import * as React from 'react';
import { Card, CardContent, Grid } from '@mui/material';
import {
    useRecordContext,
    Labeled,
    TextField,
    NumberField,
    DateField,
    BooleanField,
    useTranslate
} from 'react-admin';
import { OrderReturnItem } from '../../types';

const OrderReturnItemShow = () => {
    const record = useRecordContext<OrderReturnItem>();
    const translate = useTranslate();
    const empty = translate(`resources.order.show.none`);

    if (!record) {
        return null;
    }

    return (
        <Card sx={{ width: '100%', padding: 'none', border: 'none' }}>
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Labeled
                            source="sku"
                            label="resources.order.return.items.sku"
                        >
                            <TextField source="sku" emptyText={empty} />
                        </Labeled>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Labeled
                            source="productName"
                            label="resources.order.return.items.productName"
                        >
                            <TextField source="productName" emptyText={empty} />
                        </Labeled>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Labeled
                            source="reasonCode"
                            label="resources.order.return.items.reasonCode"
                        >
                            <TextField source="reasonCode" emptyText={empty} />
                        </Labeled>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Labeled
                            source="reasonDefaultDescription"
                            label="resources.order.return.items.reasonDefaultDescription"
                        >
                            <TextField source="reasonDefaultDescription" emptyText={empty} />
                        </Labeled>
                    </Grid>
                    {record.customerNote && (
                        <Grid item xs={12}>
                            <Labeled
                                source="customerNote"
                                label="resources.order.return.items.customerNote"
                            >
                                <TextField source="customerNote" emptyText={empty} />
                            </Labeled>
                        </Grid>
                    )}
                    <Grid item xs={12} sm={6}>
                        <Labeled
                            source="requestedQuantity"
                            label="resources.order.return.items.requestedQuantity"
                        >
                            <NumberField source="requestedQuantity" emptyText={empty} />
                        </Labeled>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Labeled
                            source="unitFullPriceAfterDiscount"
                            label="resources.order.return.items.unitFullPriceAfterDiscount"
                        >
                            <NumberField
                                source="unitFullPriceAfterDiscount"
                                options={{ style: 'currency', currency: 'EUR' }}
                                emptyText={empty}
                            />
                        </Labeled>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Labeled
                            source="isShipping"
                            label="resources.order.return.items.isShipping"
                        >
                            <BooleanField source="isShipping" />
                        </Labeled>
                    </Grid>
                    {record.updatedAt && (
                        <Grid item xs={12} sm={6}>
                            <Labeled
                                source="updatedAt"
                                label="resources.order.return.items.updatedAt"
                            >
                                <DateField
                                    source="updatedAt"
                                    showTime={true}
                                    locales="de-DE"
                                    options={{
                                        dateStyle: 'medium',
                                        timeStyle: 'short',
                                    }}
                                    emptyText={empty}
                                />
                            </Labeled>
                        </Grid>
                    )}
                </Grid>
            </CardContent>
        </Card>
    );
};

export default OrderReturnItemShow;
